import { cva } from 'class-variance-authority';
import { FC, ForwardedRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { ButtonBaseProps } from '../helpers/button.types';
import { ButtonCompoundVariants } from '../helpers/buttons.constants';

const buttonsVariants = cva(
    ['flex items-center justify-center', 'font-semibold', 'whitespace-nowrap', 'cursor-pointer'],
    {
        variants: {
            color: {
                primary: [],
                secondary: [],
                success: [],
                danger: [],
                warning: [],
            },
            variant: {
                default: [],
                shaded: [],
            },
            size: {
                xs: ['text-xs w-8 h-8 rounded-lg'],
                sm: ['text-sm w-9 h-9 rounded-[10px]'],
                normal: ['text-sm w-10 h-10 rounded-[10px]'],
                lg: ['text-base w-10 h-11 rounded-xl'],
            },
        },
        compoundVariants: ButtonCompoundVariants,
        defaultVariants: {
            color: 'primary',
            variant: 'default',
            size: 'normal',
        },
    }
);

interface IconButtonProps extends ButtonBaseProps<typeof buttonsVariants> {
    ref?: ForwardedRef<HTMLButtonElement>;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
    const { children, variant, color, size, className, ...rest } = props;

    return (
        <button ref={ref} {...rest} className={twMerge(buttonsVariants({ color, variant, size, className }))}>
            {children}
        </button>
    );
});

export default IconButton;
